import React, { useRef } from 'react'
import { useParams } from 'react-router-dom'
import { useReactToPrint } from 'react-to-print'
import { Button } from '@mui/material'
import { PageTitle } from 'uiComponents/typography'
import { BaseRouteParams } from 'hocs'
import DailyScheduleFilters from './components/dailyScheduleFilters'
import DailyScheduleTable from './table'
import { DateControls } from './components/dateControls'
import { useDateControl } from './hooks/useDateControl'
import { useOrdersData } from './hooks/useOrdersData'
import { useGetApfFieldsQuery } from 'orders/reduxQueries'
import { useTranslation } from 'translations'
import './styles.scss'

const DailySchedule: React.FC = () => {
    const { t } = useTranslation()
    const { accountSlug } = useParams<BaseRouteParams>()
    const printRef = useRef<HTMLDivElement>(null)
    const reactToPrintFn = useReactToPrint({ contentRef: printRef })
    const { selectedDate, handleDateChange, stepDate } = useDateControl()
    const { ordersCount } = useOrdersData(accountSlug, selectedDate)
    const { data: apfFields, isLoading: apfFieldsLoading } = useGetApfFieldsQuery({ accountSlug })

    return (
        <div id="orders__elem">
            <PageTitle>{t('orders.dailySchedule.title')}</PageTitle>
            <div className="controls">
                <div className="controls__row">
                    <div className="controls__left">
                        <DateControls
                            selectedDate={selectedDate}
                            handleDateChange={handleDateChange}
                            stepDate={stepDate}
                            ordersCount={ordersCount}
                        />
                    </div>
                    <div className="controls__right">
                        <Button
                            variant="outlined"
                            color="secondary"
                            size="medium"
                            onClick={() => reactToPrintFn()}
                            className="control-button"
                        >
                            {t('orders.dailySchedule.export')}
                        </Button>
                    </div>
                </div>
                <DailyScheduleFilters
                    apfFields={apfFields ?? { default: {}, custom: {} }}
                    apfFieldsLoading={apfFieldsLoading}
                />
            </div>
            <DailyScheduleTable
                selectedDate={selectedDate}
                printRef={printRef}
                apfFieldsKey={apfFields ?? { default: {}, custom: {} }}
            />
        </div>
    )
}

export default DailySchedule
